export default "__VITE_ASSET__C1wG0DqO__"